import { useEffect } from 'react';
import {
  AuthPopup,
  DepositPopup,
  LogoutPopup,
  QuickDepositPopup,
  RealityCheckPopup,
  WithdrawalPopup,
} from './ByContentType';

import usePopup from './usePopup';

import styles from './DefaultPopup.module.scss';

const DefaultPopup = () => {
  const { popup, isPopupVisible, closePopup } = usePopup('default');
  const shouldRender = isPopupVisible && popup;

  useEffect(() => {
    document.body.style.overflow = shouldRender ? 'hidden' : 'auto';

    const keyupHandler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closePopup();
      }
    };

    document.addEventListener('keyup', keyupHandler);

    return () => {
      document.removeEventListener('keyup', keyupHandler);
    };
  }, [shouldRender, closePopup]);

  return shouldRender ? (
    <>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: handling of Escape
      button made in the useEffect above */}
      <div
        className={styles.backdrop}
        onClick={popup.closeByBackdrop ? closePopup : undefined}
      />
      {popup.contentType === 'logout' && (
        <LogoutPopup data={popup.data} closePopup={closePopup} />
      )}
      {popup.contentType === 'auth' && <AuthPopup closePopup={closePopup} />}
      {popup.contentType === 'withdrawal' && (
        <WithdrawalPopup data={popup.data} closePopup={closePopup} />
      )}
      {popup.contentType === 'deposit' && (
        <DepositPopup data={popup.data} closePopup={closePopup} />
      )}
      {popup.contentType === 'quickDeposit' && (
        <QuickDepositPopup closePopup={closePopup} />
      )}
      {popup.contentType === 'realityCheck' && (
        <RealityCheckPopup data={popup.data} closePopup={closePopup} />
      )}
      {!popup.contentType && popup.content && (
        <div className={styles.modal}>
          <p>{popup.content}</p>
        </div>
      )}
    </>
  ) : null;
};

export default DefaultPopup;
